import { EnterLicenseModalTranslations } from "./types";

export const deTranslations: EnterLicenseModalTranslations = {
    title: "Lizenz eingeben",
    submitButtonText: "Absenden",
    buyNowButtonText: "Jetzt kaufen",
    dontHaveLicenseText: `Haben Sie keine Lizenz?${" "}`
};